import { formatRegApiDate } from './helpers';

/**
 * @typedef {Object} RegistrationsApiSetData
 * @property {string} country Country ID
 * @property {string} entity Entity ID
 * @property {string} [number] VAT number
 * @property {string} [number_local] Local VAT number
 * @property {string} [date_registration] Registration date
 * @property {string} [date_registration_closed] De-registration date
 * @property {string} [date_filing_start] End date for period of first filing
 * @property {string} [fiscal_code] Fiscale code
 */

/**
 * Transforms form submission data into required format for API request
 * @param {Object} [$0={}] Form data
 * @param {string} $0.entityId Entity ID
 * @param {Object} $0.jurisdiction jurisdiction info
 * @param {string} $0.jurisdiction.id jurisdiction ID
 * @param {string} $0.vatNumber VAT number
 * @param {string} [$0.vatNumberLocal] Local VAT number
 * @param {Date} $0.dateRegistration Registration date
 * @param {Date} $0.dateRegistrationClosed De-registration date
 * @param {Date} $0.dateFilingStart End date for period of first filing
 * @param {string} $0.registrationType registration subtype
 * @param {string} [$0.fiscaleCode] Fiscale code
 * @returns {RegistrationsApiSetData} Transformed data
 */

export const registrationsDetailsSetModel = ({
  jurisdiction,
  dateFilingStart,
  dateRegistration,
  dateRegistrationClosed,
  entityId,
  fiscaleCode,
  vatNumber,
  vatNumberLocal,
  registrationType,
} = {}) => ({
  taxable_jurisdiction: jurisdiction?.id,
  date_filing_start: formatRegApiDate(dateFilingStart),
  date_registration: formatRegApiDate(dateRegistration),
  date_registration_closed: formatRegApiDate(dateRegistrationClosed),
  entity: entityId,
  fiscal_code: fiscaleCode,
  number: vatNumber,
  number_local: vatNumberLocal,
  registration_sub_type: registrationType,
});
